import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../_base/FIELD__base_connectable';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';

export class FIELD_SD__conditioning extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_SD__CONDITIONING;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  /*
   * PROPERTIES
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.meta.field_hash__value_full;
  }

  field_connectable__type() {
    return ENUM__field_connectable_type.CONDITIONING_SD;
  }

  /*
   *
   */

  @DECORATOR__ui_without_component
  post_init() {
    super.post_init();
  }

  /*
   * HASH
   */
  /*
   * VALIDATION
   */

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.meta.kind__is_input) return false;

    return super.has_effect_on_generation_runtime(graph);
  }
}
